import {useCallback} from 'react';

import {useAppSelector} from './redux';

export const useGetMinerNetworkId = () => {
  const minerAddressMask = useAppSelector(
    ({assets}) => assets.constants?.miner.address_mask
  );

  const getMinerNetworkId = useCallback((commtracExternalId?: number | null) => {
    if (commtracExternalId && minerAddressMask) {
      // eslint-disable-next-line no-bitwise
      return commtracExternalId & minerAddressMask;
    } else {
      return null;
    }
  }, []);
  return getMinerNetworkId;
};
